'use client';
import React from 'react';
import AppLayout from '@/components/AppLayout';
import FeaturedChampion from './components/FeaturedChampion';
import HallStats from './components/HallStats';
import AchievementGrid from './components/AchievementGrid';
import { useLanguage } from '@/contexts/LanguageContext';

// Backend integration point: fetch /api/hall-of-fame with featured, achievements, and stats

export default function HallOfFamePage() {
  const { t } = useLanguage();

  return (
    <AppLayout activeRoute="/hall-of-fame">
      {/* Header */}
      <div className="mb-8">
        <div className="flex items-center gap-2 mb-3">
          <span
            className="text-xs font-bold uppercase tracking-widest"
            style={{ color: '#f59e0b', letterSpacing: '0.08em' }}
          >
            {t('hof_prestige')}
          </span>
        </div>
        <h1 className="text-hero font-extrabold mb-3" style={{ color: 'var(--foreground)' }}>
          {t('hof_title')}
        </h1>
        <p className="text-sm max-w-xl" style={{ color: 'var(--muted-foreground)' }}>
          {t('hof_desc')}
        </p>
      </div>
      {/* Featured Champion */}
      <FeaturedChampion />
      {/* Hall Stats */}
      <HallStats />
      {/* Achievement Grid */}
      <div className="card-glass p-6">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-lg font-bold" style={{ color: 'var(--foreground)' }}>
              {t('hof_all_achievements')}
            </h2>
            <p className="text-xs mt-1" style={{ color: 'var(--muted-foreground)' }}>
              {t('hof_filter')}
            </p>
          </div>
          <div
            className="flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-semibold"
            style={{ background: 'rgba(245,158,11,0.1)', color: '#f59e0b', border: '1px solid rgba(245,158,11,0.2)' }}
          >
            {t('hof_achievements_count')?.replace('{n}', '11')}
          </div>
        </div>
        <AchievementGrid />
      </div>
    </AppLayout>
  );
}